angular.module('mtic').service('preliveCheck', function () {
    // Init Event Manager
    var isQC = window.location.href.indexOf('edge') > -1 || window.location.href.indexOf('preview') > -1 || window.location.href.indexOf('localhost') > -1;
    var isPrelive = (window.location.href.indexOf('pre-live') > -1) || (window.location.href.indexOf('prelive2') > -1)
    return {
      isPreliveCheck(){
        return isPrelive;
      },
      isQCCheck(){
        return isQC;
      }
    }
})
